import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../environments/environment";
import {Customer} from "../interface/customer";

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  private baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  get(id: number): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/customer/${id}`);
  }
  getCollection(): Observable<Customer[]>{
    return this.http.get<Customer[]>(`${this.baseUrl}/get/customer`);
  }

  getCustomerRegistrationByClass(id: number): Observable<any>{
    console.log(id);
    return this.http.get(`${this.baseUrl}/get/customer/registration/by/class/${id}`);
  }

  getItemFeesByCustomerRegistration(id: number): Observable<any>{
    console.log(id);
    return this.http.get(`${this.baseUrl}/get/customer/registration/item/fees/${id}`);
  }
  post(data: Customer): Observable<any>{
    return this.http.post<Customer>(`${this.baseUrl}/create/customer`, data);
  }

  put(id: number, data: Customer): Observable<any>{
    return this.http.put<Customer>(`${this.baseUrl}/edit/customer/${id}`, data);
  }
  delete(id: number): Observable<Customer>{
    return this.http.delete<Customer>(`${this.baseUrl}/delete/customer/` + id);
  }
  deleteMultiple(ids: number[]): Observable<Customer[]>{
    const options = {body: ids};
    return this.http.delete<Customer[]>(`${this.baseUrl}/delete/selected/customer`, options);
  }

  import(datas: any[]): Observable<any>{
    console.log(datas);
    let options = {data: datas};
    return this.http.post(`${this.baseUrl}/import/customer`, options);
  }

}
